import React, { useEffect, useState } from 'react'
import { Button, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

const { Text } = Typography

const useLandingPage = () => {
  const token = localStorage.getItem('token')
  const [groupData, setGroupData] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(0)
  const [chartLoading, setChartLoading] = useState(true)
  const [statusData, setStatusData] = useState(null)
  const [completionData, setCompletionData] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    fetchDashboardData()
  }, [])

  useEffect(() => {
    fetchMentorGroups()
  }, [page, pageSize])

  const fetchMentorGroups = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/InternshipGroup/Mentor/Groups`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: '*/*',
          },
          params: { pageNumber: page, pageSize },
        },
      )
      // Server-side pagination: base endpoint (no /lookup) returns { items, totalCount }.
      const d = response.data
      if (Array.isArray(d)) {
        setGroupData(d)
        setTotal(d.length)
      } else {
        setGroupData(d?.items ?? [])
        setTotal(d?.totalCount ?? 0)
      }
    } catch (error) {
      console.error('Error fetching mentor groups:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchDashboardData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL_API}/Mentor/Dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: '*/*',
        },
      })
      const { projectStatusChart, completionStatusChart } = response.data
      setStatusData({
        labels: projectStatusChart.map((item) => item.projectName),
        datasets: [
          {
            label: '',
            data: projectStatusChart.map((item) => item.completionPercentage),
            backgroundColor: ['#3F51B5', '#009688', '#9C27B0'],
            barThickness: 20,
          },
        ],
      })

      // Completion Status Chart Data
      setCompletionData({
        labels: completionStatusChart.map((item) => item.status),
        datasets: [
          {
            data: completionStatusChart.map((item) => item.count),
            backgroundColor: ['#4CAF50', '#FF9800', '#F44336'],
          },
        ],
      })
    } catch (error) {
      console.error('Error fetching dashboard data:', error)
    } finally {
      setChartLoading(false)
    }
  }

  const columns = [
    {
      title: 'Group ID',
      key: 'groupId',
      render: (_, record) => record.groupPublicId || record.groupId,
    },
    {
      title: 'Group Name',
      dataIndex: 'groupName',
      key: 'groupName',
    },
    {
      title: 'Created On',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: 'Assigned Project',
      dataIndex: 'projectName',
      key: 'projectName',
      render: (text) =>
        text ? text : <Text style={{ color: 'red', fontWeight: 'bold' }}>Not Assigned</Text>,
    },
    {
      title: 'Number of Students',
      dataIndex: 'membersCount',
      key: 'membersCount',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => navigate(`/group-detail/${record.id ?? record.groupId}`)}
        >
          View Detail
        </Button>
      ),
    },
  ]

  return {
    groupData,
    loading,
    columns,
    chartLoading,
    statusData,
    completionData,
    page,
    pageSize,
    total,
    setPage,
    setPageSize,
  }
}

export default useLandingPage
